import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ConfirmationComponent} from './confirmation/confirmation.component';
import {OfflineactivationComponent} from './offlineactivation/offlineactivation.component';
import {HomepageComponent} from './homepage/homepage.component';
import {ThankyouComponent} from './thankyou/thankyou.component';
import {RegistrationComponent} from './registration/registration.component';
import {ThankyoudesktopComponent} from "./thankyoudesktop/thankyoudesktop.component";


const routes: Routes = [
  { path: 'confirm/:uid/:rid', component: ConfirmationComponent },
  { path: 'confirm', component: ConfirmationComponent },
  { path: 'offlineactivation', component: OfflineactivationComponent },
  { path: 'thankyou', component: ThankyoudesktopComponent },
  { path: 'thankyoudesktop', component: ThankyoudesktopComponent },
  { path: '', component: RegistrationComponent },
  { path: 'install', component: HomepageComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
